// extracted by mini-css-extract-plugin
export default {"item":"Tab_item__uL8Ns","active":"Tab_active__gk3+R"};